import { applyFilters, doRequest } from "./helpers";

export const META_LEADS_EVENTS_QUERY_KEY = "meta-leads-events";

export default class MetaLeadsEventService {
  static async list() {
    return doRequest("GET", "/meta_leads_events");
  }

  static async getTable(filters = null) {
    let path = "/meta_leads_events/table";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async create(data) {
    return doRequest("POST", "/meta_leads_events", { data });
  }

  static async update(id, data) {
    return doRequest("PUT", `/meta_leads_events/${id}`, { data });
  }

  static async remove(id) {
    return doRequest("DELETE", `/meta_leads_events/${id}`);
  }
}
